var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H4.99998C4.30831 0.5 3.71665 0.916666 3.46665 1.51667L0.94998 7.39167C0.87498 7.58333 0.833313 7.78333 0.833313 8V9.66667C0.833313 10.5833 1.58331 11.3333 2.49998 11.3333H7.75831L6.96665 15.1417L6.94165 15.4083C6.94165 15.75 7.08331 16.0667 7.30831 16.2917L8.19165 17.1667L13.6833 11.675C13.9833 11.375 14.1666 10.9583 14.1666 10.5V2.16667C14.1666 1.25 13.4166 0.5 12.5 0.5ZM15.8333 0.5V10.5H19.1666V0.5H15.8333Z",
    fill: "#BA1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.91e8dd87.svg";
export { ForwardRef as ReactComponent };